import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import classnames from 'classnames';
import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import withPlaceholder from '@deliveroo/consumer-component-library/components/withPlaceholder';

import FilterTag from '../FilterTag';
import HomeTitle from '../HomeTitle';

import styles from './styles.scss';

const HomeSummary = ({
  subtitle,
  isPlaceholder,
  onClickBackToRestaurants,
  appliedFilters,
  handleClearFilter,
  title,
  titleLink,
}) => {
  const hasAppliedFilters = appliedFilters && !!appliedFilters.length;

  return (
    <div className={styles.container}>
      <div className={classnames(styles.header, { [styles.collection]: titleLink })}>
        <div className={styles.desktopTitle}>
          <HomeTitle
            title={title}
            titleLink={titleLink}
            onClick={onClickBackToRestaurants}
            isPlaceholder={isPlaceholder}
          />
        </div>
      </div>
      {hasAppliedFilters && (
        <div className={styles.filtersWrapper}>
          <div className={styles.filterTagSection}>
            {appliedFilters.map((filter) => (
              <Spacer key={filter.label} adjacentHorizontalSpacing="small">
                <FilterTag
                  label={filter.label}
                  onClose={() => handleClearFilter(filter.target_params)}
                  isPlaceholder={isPlaceholder}
                />
              </Spacer>
            ))}
          </div>
        </div>
      )}
      {subtitle &&
        !isPlaceholder && (
          <P color="grey" size="small" spacing="0 0 small 0">
            {subtitle}
          </P>
        )}
    </div>
  );
};

HomeSummary.propTypes = {
  /** page title used when in a collection view */
  title: PropTypes.string,

  /** page subtitle used to show the restaurant count */
  subtitle: PropTypes.string,

  /** page title for restaurant list, also used for back link when in collection view */
  titleLink: PropTypes.string,

  /** Callback to handle clicking "Back to restaurants" */
  onClickBackToRestaurants: PropTypes.func,

  appliedFilters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      target_params: PropTypes.shape({
        queryParams: isRequiredIf(PropTypes.string, ({ isPlaceholder }) => !isPlaceholder),
      }),
    }),
  ),

  /** Callback to handle dismissing a filter tag */
  handleClearFilter: PropTypes.func,

  /** render placeholder content */
  isPlaceholder: PropTypes.bool,
};

HomeSummary.defaultProps = {
  title: '',
  subtitle: '',
  titleLink: '',
  isPlaceholder: false,
  onClickBackToRestaurants: undefined,
  appliedFilters: undefined,
  handleClearFilter: undefined,
};

HomeSummary.placeholderProps = {
  subtitle: 'placeholder',
  onClickBackToRestaurants: () => undefined,
};

export default withPlaceholder(HomeSummary);
